export default __webpack_public_path__ + "static/media/img10.b4501a00.jpg";